<template>
  <div v-if="$store.state.global.themes" id="themesTab">
    <b-row>
      <b-col>
        <b-form-group>
          <search-input v-model="query" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-col class="text-right">
          <b-button v-router-link="{name:'theme-editor',query: { category_id: $store.state.global.category.id }}" variant="outline-primary">
            <i class="fa fa-plus-circle" /> Add Theme
          </b-button>
        </b-col>
      </b-col>
    </b-row>

    <b-card-group columns>
      <b-card no-body
        v-for="theme in displayThemes"
        :key="theme.id"
        v-router-link="{ name:'theme-detail', params: theme}"
        
      >
        <img :src="'https://cdn.gokaizen.com/' + theme.src" alt="" style="max-width:100%;">
        <b-card-body>
          <h3>{{ theme.name }}</h3>
        </b-card-body>
      </b-card>
    </b-card-group>
    <div v-if="displayThemes.length == 0" class="text-center">
      No results
    </div>
  </div>
</template>

<script>
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';

export default {
  name: 'MediacategoryThemesTab',

  components: {
    SearchInput,
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    displayThemes() {
      return $search(this.$store.state.global.themes, this.query);
    },
  },
};
</script>
